<template>
  <v-container class="gates" fluid>
    <div class="gates-header">
      <h1 class="gates-header__title">{{ $route.meta.title }}</h1>
      <div class="gates-header__actions">
        <v-menu
          v-if="disableFilterName"
          bottom
          left
          offset-y
          origin="bottom left"
          transition="scale-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              outlined
              class="gates-header__btn text-none"
              dark
              rounded
              v-bind="attrs"
              v-on="on"
            >
              <v-icon left>mdi-download</v-icon>
              Скачать отчёт
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="downloadReportPage()">
              <v-list-item-icon class="mr-2">
                <v-icon small>mdi-file-table-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Отчёт на странице</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn
          v-if="$checkPermission('store_gate')"
          color="primary"
          class="gates-header__btn text-none"
          dark
          rounded
          to="/base-gate/new"
        >
          <v-icon left>mdi-plus</v-icon>
          Новая калитка
        </v-btn>
      </div>
    </div>

    <v-card class="gates-block mt-3" flat outlined>
      <div class="gates-filters">
        <div class="gates-filters__title">
          <v-icon left small>mdi-filter-variant</v-icon>
          Фильтры
        </div>
        <div class="filters-gates">
          <v-text-field
            v-model="filterAddress"
            placeholder="Улица"
            outlined
            dense
            hide-details
            prepend-inner-icon="mdi-rename-box-outline"
            class="gates-filters__field"
          />
          <v-autocomplete
            v-model="sipStatusSearched"
            placeholder="Статус"
            :items="sipSelectList"
            item-text="text"
            item-value="text"
            prepend-inner-icon="mdi-progress-clock"
            outlined
            dense
            hide-details
            clearable
            class="gates-filters__field"
          />
          <v-autocomplete
            label="Тип калитки"
            v-model="filterType"
            :items="typesGates"
            item-text="name"
            item-value="value"
            prepend-inner-icon="mdi-alert-circle-outline"
            outlined
            dense
            hide-details
            clearable
            class="gates-filters__field"
          />
          <v-autocomplete
            v-if="disableFilterName"
            label="Агент"
            v-model="filterAgent"
            :items="agents"
            item-text="user.name"
            item-value="user.name"
            prepend-inner-icon="mdi-account-search"
            outlined
            dense
            hide-details
            clearable
            class="gates-filters__field"
          />
        </div>
      </div>
      <v-divider class="my-0" />
      <v-data-table
        class="table row-click"
        :headers="headersGates"
        :items="filteredGates"
        :options.sync="options"
        :footer-props="{
          'items-per-page-options': [20, 50, 100],
          showFirstLastPage: true,
        }"
        @click:row="rowDetailGate"
      >
        <template v-slot:header.snapshotImage>
          Изображение
          <v-icon @click="showSnapshot = !showSnapshot">mdi-image</v-icon>
        </template>
        <template v-slot:item.created_at="{ item }" v-if="!isDisplaySmall">
          {{ ruDateFormat(item.created_at) }}
        </template>
        <template v-slot:item.sipStatus="{ item }" v-if="!isDisplaySmall">
          <div>
            <v-icon x-small :color="item.sip_status_color">
              mdi-checkbox-blank-circle
            </v-icon>
            {{ item.sip_status_text }}
          </div>
        </template>
        <template v-slot:body="{ items }" v-if="isDisplaySmall">
          <tbody class="table" v-if="items.length">
          <tr
            v-for="(item, index) in items" :key="index"
            @click.middle="clickGateWhell(item)"
            @click.prevent="clickGate($event, item)"
          >
            <td>{{ item.id }}</td>
            <td>{{ item.address }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.model }}</td>
            <td>{{ item.agent }}</td>
            <td>
              <div>
                <v-icon x-small :color="item.sip_status_color">
                  mdi-checkbox-blank-circle
                </v-icon>
                {{ item.sip_status_text }}
              </div>
            </td>
            <td>
              <v-img
                v-show="showSnapshot"
                v-if="item.snapshot"
                :src="`${item.snapshot}`"
                max-width="150"
                class="ml-auto mr-auto my-4"
                contain
              ></v-img>
              <v-img
                v-show="showSnapshot"
                v-else
                :src="require('../../public/controller.jpg')"
                max-width="100"
                class="ml-auto mr-auto my-4"
                contain
              ></v-img>
            </td>
          </tr>
          </tbody>
          <tbody v-else>
          <tr>
            <td colspan="10" style="text-align: center">Отсутствуют данные</td>
          </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ruDateFormatMixin from '@/mixins/ruDateFormat';
import cp1251Mixin from '@/mixins/cp1251Encode';

export default {
  name: 'Gates',
  mixins: [ruDateFormatMixin, cp1251Mixin],
  data () {
    return {
      isCreated: false,
      filters: {},
      combinedDataGates: [],
      sipStatusSearched: '',
      disableRoleName: false,
      filterAddress: '',
      filterAgent: '',
      isBtnFiltersSmall: false,
      isDisplaySmall: true,
      showSnapshot: false,
      disableFilterName: true,
      filterType: '',
      options: {
        sortBy: ['id'],
        sortDesc: [true],
        page: 1,
        itemsPerPage: 20,
      },
      typesGates: [
        { name: 'Калитка (колясочная)', value: 'RACS-1101' },
        { name: 'Калитка-домофон', values: ['RV-3438', 'RV-3434', 'DKS15134', 'DKS20211'] },
      ],
      sipSelectList: [
        { text: 'Отключен', value: '0' },
        { text: 'Регистрация', value: '1' },
        { text: 'Зарегистрирован', value: '2' },
        { text: 'Не удалось зарегистрироваться', value: '3' },
        { text: 'Не установлен', value: '4' },
        { text: 'Без интернет соединения', value: '5' },
        { text: 'Пусконаладка', value: '6' },
        { text: 'Старый домофон', value: '7' },
        { text: 'Не в сети', value: 'null' },
        { text: 'Не зарегистрирован', value: '-1' },
      ],
    };
  },
  watch: {
  },
  async created () {
    this.isCreated = true;
    switch (this.roleName) {
      case 'call-center' : case 'manager' : case 'master' : this.disableFilterName = false;
        break;
    }
    if (this.disableFilterName) {
      // this.loadAllAgents();
    }
    await this.loadGates();
    window.addEventListener('resize', this.checkSize);
    this.checkSize();
  },
  computed: {
    ...mapGetters({
      roleName: 'roleName',
      gates: 'Gate/gates',
      agents: 'Agents/agents',
      doorphones: 'Doorphone/doorphones',
    }),
    headersGates () {
      const headers = [
        {
          text: 'id',
          value: 'id',
          sortable: true,
        },
        {
          text: 'Адрес',
          value: 'address',
          width: '26%',
          sortable: true,
        },
        {
          text: 'Название',
          value: 'name',
          sortable: false,
        },
        {
          text: 'Модель устройства',
          value: 'model',
          sortable: false,
        },
        {
          text: 'agent',
          value: 'agent',
          sortable: false,
        },
        {
          text: 'Статус',
          value: 'sipStatus',
          width: '13%',
          sortable: false,
        },
      ];
      if (this.isDisplaySmall) {
        headers.push({
          text: 'Изображение',
          value: 'snapshotImage',
          width: '13%',
          sortable: false,
        });
      }
      return headers;
    },
    filteredGates () {
      let gates = this.combinedDataGates;
      // Фильтрация по адресу
      if (this.filterAddress) {
        gates = gates.filter(gate => {
          return gate.address.toLowerCase().includes(this.filterAddress.toLowerCase());
        });
      }
      // Фильтрация по SIP статусу
      if (this.sipStatusSearched) {
        gates = gates.filter(gate => {
          return gate.sip_status_text.toLowerCase().includes(this.sipStatusSearched.toLowerCase());
        });
      }
      // Фильтрация по агенту
      if (this.filterAgent) {
        gates = gates.filter(gate => {
          return gate.agent.toLowerCase().includes(this.filterAgent.toLowerCase());
        });
      }
      // Фильтрация по типу
      if (this.filterType) {
        gates = gates.filter(gate => {
          const filterType = this.typesGates.find(type => type.name === this.filterType);
          if (filterType) {
            if (Array.isArray(filterType.values)) {
              // Фильтрация, несколько значений
              return filterType.values.includes(gate.model);
            }
          }
          return gate.model.toLowerCase().includes(this.filterType.toLowerCase());
        });
      }

      return gates;
    },

  },
  methods: {
    ...mapActions({
      loadAllGates: 'Gate/loadAllGates',
      loadAllAgents: 'Agents/loadAllAgents',
      getDoorphones: 'Doorphone/getDoorphones',
    }),
    checkSize () {
      this.isBtnFiltersSmall = window.innerWidth <= 600;
      this.isDisplaySmall = window.innerWidth >= 600;
    },
    clickGate (event, value) {
      if (this.$canRoute('DetailGate')) {
        if (event.ctrlKey) {
          this.clickGateWhell(value);
        } else {
          this.detailGate(value);
        }
      }
    },
    clickGateWhell (item) {
      let roterName = 'DetailGate';
      if (item.type) {
        roterName = 'DetailDoorphone';
      }
      const routeData = this.$router.resolve({ name: `${roterName}`, params: { id: item.id } });
      window.open(routeData.href, '_blank');
    },
    detailGate (value) {
      let { id } = value.id;
      if (!id) {
        id = value.id;
      }
      let roterName = 'DetailGate';
      if (value.type) {
        roterName = 'DetailDoorphone';
      }
      this.$router.push({ name: `${roterName}`, params: { id: id } });
    },
    rowDetailGate (value) {
      if (!this.isDisplaySmall) {
        this.detailGate(value);
      }
    },
    downloadReportPage () {
      const lines = [];
      this.combinedDataGates.forEach((item) => {
        const line = [
          item.id, item.address, item.name, item.model, item.agent, item.sip_status_text,
        ].join(';');
        lines.push(line);
      });
      const link = document.createElement('a');
      link.href = `data:text/csv;charset=CP1251,${this.encodeCP1251(lines.join('\n'))}`;
      link.download = 'gates.csv';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    loadDoorphones () {
      this.getDoorphones({
        filters: { type: 'G' },
        limit: 999,
      })
        .then(() => {
        })
        .catch((error) => {
          console.error(error);
          this.$sentry_exception(error);
          this.$flash_warning('Ошибка при загрузке информации');
        })
        .finally(() => {
          this.combinedDataGates = [...this.gates, ...this.doorphones];
        });
    },
    loadGates () {
      this.$router.push({
        query: {
          address: this.filters.address,
          status: this.filters.status,
          agent: this.filters.agent_id,
        },
      }).catch(() => {});
      this.loadAllGates({
        filters: this.filters,
        limit: 999,
      })
        .then(() => {
          if (this.roleName !== 'master') {
            this.loadDoorphones();
          } else {
            this.combinedDataGates = [...this.gates];
          }
        })
        .catch((error) => {
          console.error(error);
          this.$sentry_exception(error);
          this.$flash_warning('Ошибка при загрузке калиток');
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.gates-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 8px 0;
}

.gates-header__title {
  font-size: 1.5rem;
  font-weight: 400;
  color: #37474f;
  margin: 0;
  letter-spacing: -0.02em;
}

.gates-header__actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.gates-header__btn {
  text-transform: none;
  font-weight: 500;
}

.gates-block {
  border-radius: 12px;
  overflow: hidden;
}

.gates-filters {
  padding: 10px 24px 8px;
}

.gates-filters__title {
  font-size: 0.875rem;
  font-weight: 600;
  color: #546e7a;
  padding: 0 0 8px 0;
  margin: 0;
  display: flex;
  align-items: center;
}

.filters-gates {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px 60px;
  align-items: flex-start;
  width: 100%;
}

.gates-filters__field {
  flex: 1;
  min-width: 160px;
}

.row-click {
  cursor: pointer;
}

.routerLink {
  text-decoration: none;
}

.v-application a {
  color: #434850;
}

a:hover.routerLink {
  text-decoration: underline;
}

@media screen and (max-width: 600px) {
  .gates-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .gates-header__title {
    font-size: 1.4rem;
  }

  .filters-gates {
    flex-direction: column;
  }

  .gates-filters__field {
    flex: none;
    min-width: 0;
  }
}
</style>
